



























































































































































import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import TaxObligationPayload, { TaxObligationLiability } from "@/dto/tax/TaxObligationPayload";
import TaxObligationService from "@/services/TaxObligationService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import { YEARS, Period } from "@/constants/DateTimeConstants";
import { TaxObligationStatus } from "@/constants/TaxObligationStatus";
import { STATE_LIST } from "@/constants/ProfileConstants";
import { PaymentStatus } from "@/constants/PaymentConstants";
import { Risk } from "@/constants/Risk";
import SelectOption from "@/components/common/SelectOption";
import SublimeSearch from "@/components/common/SublimeSearch.vue";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import { TaxReportForm, getTaxReportFormLabel } from "@/constants/TaxReportForm";
import { 
  TaxObligationLiabilityType, 
  TaxObligationLiabilityMapping,
  getDefaultLiabilitiesForForm,
  getTaxObligationLiabilityTypeLabel
} from "@/constants/TaxObligationLiabilityType";

@Component({
  components: {
    SimpleProfileSearch,
    PortalInput,
    PortalSelect,
    SublimeSearch
  }
})
export default class CreateTaxObligationModal extends Vue {
  
  private form: any = {
    liabilities: []
  };
  private customerProfile: ProfileDTO | null = null;
  private assignee: SublimeEmployeeDTO | null = null;

  public beforeOpen(): void {
    this.form = {
      year: new Date().getFullYear(),
      period: null as any,
      periodStart: null,
      periodEnd: null,
      reportFilingDeadline: '',
      paidOn: null,
      status: TaxObligationStatus.SCHEDULED,
      paymentStatus: PaymentStatus.UNPAID,
      risk: Risk.LOW,
      obligation: '',
      nextAction: '',
      taxReportForm: null as any,
      state: null,
      liabilities: [],
      customerId: null as any,
      customerType: null as any,
      assigneeId: null as any
    };
    this.customerProfile = null;
    this.assignee = null;
    // reset validation if vee-validate is used
    if (this.$validator) {
      this.$validator.reset();
    }
  }

  public closeModal(): void {
    this.$modal.hide('create-tax-obligation-modal');
  }

  public onCustomerSelected(profile: ProfileDTO | null): void {
    if (profile) {
      this.form.customerId = profile.id;
      this.form.customerType = profile.type as any;
    } else {
      this.form.customerId = null as any;
      this.form.customerType = null as any;
    }
  }
  
  public onAssigneeSelected(employee: SublimeEmployeeDTO | null): void {
    this.assignee = employee;
    if (employee) {
      this.form.assigneeId = employee.id;
    } else {
      this.form.assigneeId = null as any;
    }
  }

  public onObligationTypeChange(): void {
    this.form.liabilities = [];
    if (this.form.taxReportForm) {
      const defaults = getDefaultLiabilitiesForForm(this.form.taxReportForm);
      defaults.forEach(type => {
        this.form.liabilities.push({
          type: type,
          amountCents: 0
        });
      });

      if (this.form.liabilities.length === 0) {
        this.addLiability();
      }
    }
    this.updateReportFilingDeadline();
  }

  public updatePeriodDates(): void {
    const year = this.form.year;
    const period = this.form.period;

    if (!year || !period || period === Period.CUSTOM || period === Period.FISCAL_YEAR) {
      this.form.periodStart = null;
      this.form.periodEnd = null;
      this.updateReportFilingDeadline();
      return;
    }

    let start = moment().year(year).startOf('year');
    let end = moment().year(year).endOf('year');

    switch (period) {
      case Period.JANUARY: start.month(0).startOf('month'); end.month(0).endOf('month'); break;
      case Period.FEBRUARY: start.month(1).startOf('month'); end.month(1).endOf('month'); break;
      case Period.MARCH: start.month(2).startOf('month'); end.month(2).endOf('month'); break;
      case Period.APRIL: start.month(3).startOf('month'); end.month(3).endOf('month'); break;
      case Period.MAY: start.month(4).startOf('month'); end.month(4).endOf('month'); break;
      case Period.JUNE: start.month(5).startOf('month'); end.month(5).endOf('month'); break;
      case Period.JULY: start.month(6).startOf('month'); end.month(6).endOf('month'); break;
      case Period.AUGUST: start.month(7).startOf('month'); end.month(7).endOf('month'); break;
      case Period.SEPTEMBER: start.month(8).startOf('month'); end.month(8).endOf('month'); break;
      case Period.OCTOBER: start.month(9).startOf('month'); end.month(9).endOf('month'); break;
      case Period.NOVEMBER: start.month(10).startOf('month'); end.month(10).endOf('month'); break;
      case Period.DECEMBER: start.month(11).startOf('month'); end.month(11).endOf('month'); break;

      case Period.QUARTER_1: start.quarter(1).startOf('quarter'); end.quarter(1).endOf('quarter'); break;
      case Period.QUARTER_2: start.quarter(2).startOf('quarter'); end.quarter(2).endOf('quarter'); break;
      case Period.QUARTER_3: start.quarter(3).startOf('quarter'); end.quarter(3).endOf('quarter'); break;
      case Period.QUARTER_4: start.quarter(4).startOf('quarter'); end.quarter(4).endOf('quarter'); break;

      case Period.WINTER:
        // Winter: Dec (Prev Year), Jan, Feb. OR Dec, Jan, Feb of same year? 
        // Usually Winter = Dec, Jan, Feb.
        start.month(11).subtract(1, 'year').startOf('month');
        end.month(1).endOf('month');
        break;
      case Period.SPRING:
        start.month(2).startOf('month'); // March
        end.month(4).endOf('month'); // May
        break;
      case Period.SUMMER:
        start.month(5).startOf('month'); // June
        end.month(7).endOf('month'); // August
        break;
      case Period.FALL:
        start.month(8).startOf('month'); // September
        end.month(10).endOf('month'); // November
        break;
      case Period.FULL_YEAR:
        start.startOf('year');
        end.endOf('year');
        break;
    }

    this.form.periodStart = start.format('YYYY-MM-DD');
    this.form.periodEnd = end.format('YYYY-MM-DD');
    this.updateReportFilingDeadline();
  }

  public updateReportFilingDeadline(): void {
    if (!this.form.taxReportForm || !this.form.periodEnd) {
      return;
    }

    const periodEnd = moment(this.form.periodEnd);
    let deadline: moment.Moment | null = null;

    switch (this.form.taxReportForm) {
      case TaxReportForm.FORM_941:
        // Последний день месяца, следующего за отчетным периодом
        deadline = periodEnd.add(1, 'month').endOf('month');
        break;
      case TaxReportForm.FORM_940:
        // 31 января следующего года
        deadline = periodEnd.add(1, 'year').month(0).date(31);
        break;
      case TaxReportForm.FORM_1120:
        // 15-е число четвертого месяца после окончания периода (3 полных месяца + 15 дней)
        deadline = periodEnd.add(3, 'months').add(15, 'days');
        break;
      case TaxReportForm.FORM_1120S:
      case TaxReportForm.FORM_1065:
        // 15-е число третьего месяца после окончания периода (2 полных месяца + 15 дней)
        deadline = periodEnd.add(2, 'months').add(15, 'days');
        break;
      case TaxReportForm.SALES_TAX_REPORT:
        // 20-е число следующего месяца
        deadline = periodEnd.add(1, 'month').date(20);
        break;
      default:
        // Для остальных форм не меняем автоматически или оставляем как есть
        break;
    }

    if (deadline) {
      this.form.reportFilingDeadline = deadline.format('YYYY-MM-DD');
    }
  }

  public addLiability(): void {
    this.form.liabilities.push({
      type: null as any,
      amountCents: 0
    });
  }

  public removeLiability(index: number): void {
    this.form.liabilities.splice(index, 1);
  }

  public getTaxReportFormLabel(type: TaxReportForm): string {
    return getTaxReportFormLabel(type);
  }

  public getTaxObligationLiabilityTypeLabel(type: TaxObligationLiabilityType): string {
    return getTaxObligationLiabilityTypeLabel(type);
  }

  get canAddLiability(): boolean {
    if (!this.form.taxReportForm) return false;
    const allowedTypes = (TaxObligationLiabilityMapping as any)[this.form.taxReportForm] || [];
    const currentTypes = this.form.liabilities.map((l: any) => l.type).filter((t: any) => !!t);
    return currentTypes.length < allowedTypes.length;
  }

  public getLiabilityTypeOptions(currentType: TaxObligationLiabilityType): SelectOption[] {
    if (!this.form.taxReportForm) return [];
    const allowedTypes = (TaxObligationLiabilityMapping as any)[this.form.taxReportForm] || [];
    return allowedTypes.map((type: TaxObligationLiabilityType) => 
      SelectOption.builder().title(getTaxObligationLiabilityTypeLabel(type)).value(type).build()
    );
  }
  
  get isValid(): boolean {
    if (this.$validator && this.$validator.errors.items.length > 0) return false;
    const basicValid = !!(this.form.customerId && this.form.taxReportForm && this.form.year && this.form.period && this.form.reportFilingDeadline && this.form.periodStart && this.form.periodEnd);
    const stateValid = !this.isStateRequired || !!this.form.state;
    const liabilitiesValid = this.form.liabilities && this.form.liabilities.length > 0 && this.form.liabilities.every((l: any) => !!l.type && !!l.amountCents);
    return basicValid && stateValid && liabilitiesValid;
  }

  get isStateRequired(): boolean {
    const formsRequiringState = [
      TaxReportForm.FORM_1120,
      TaxReportForm.FORM_1120S,
      TaxReportForm.FORM_1065,
      TaxReportForm.SALES_TAX_REPORT,
      TaxReportForm.ANNUAL_REPORT
    ];
    return formsRequiringState.includes(this.form.taxReportForm as TaxReportForm);
  }

  get stateOptions() {
    return STATE_LIST.map(state => SelectOption.builder().title(state).value(state).build());
  }

  get obligationTypeOptions() {
    return Object.values(TaxReportForm).map(type =>
      SelectOption.builder().title(getTaxReportFormLabel(type)).value(type).build()
    );
  }

  get yearOptions() {
    return YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
  }

  get periodOptions() {
    return Object.values(Period).map(period => SelectOption.builder().title(this.$t('period.enum.' + period) as string).value(period).build());
  }

  get statusOptions() {
    return Object.values(TaxObligationStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  get paymentStatusOptions() {
    return Object.values(PaymentStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  get riskOptions() {
    return Object.values(Risk).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  public async submit(): Promise<void> {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.isValid) return;

    const payload: TaxObligationPayload = {
      ...this.form,
      liabilities: this.form.liabilities
    } as TaxObligationPayload;

    this.$loadOn();
    try {
      await TaxObligationService.createTaxObligation(payload);
      this.closeModal();
      this.$emit('created');
    } catch (e) {
      processError(e, this);
    } finally {
      this.$loadOff();
    }
  }
}
